import React, { useRef } from 'react';
import { Input } from 'antd';

const DebouncedInput = ({
  value,
  onChange,
  onDebouncedChange,
  debounceTime = 3000,
  ...rest
}) => {
  const timerRef = useRef(null);

  const handleChange = (e) => {
    const newValue = e.target.value;
    if (onChange) {
      onChange(newValue);
    }

    // Clear previous debounce timer
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    // Set new debounce timer
    timerRef.current = setTimeout(() => {
      if (onDebouncedChange) {
        onDebouncedChange(newValue);
      }
    }, debounceTime);
  };

  return (
    <Input
      value={value}
      onChange={handleChange}
      {...rest}
    />
  );
};

export default DebouncedInput;
